export const selectCateringSearchedCustomer = (state) => state.cateringCustomer.searchedCustomer;
export const selectCateringSearchedCustomerId = (state) => state.cateringCustomer.searchedCustomer?.id;
export const selectCateringCreatedCustomer = (state) => state.cateringCustomer.createdCustomer;
export const selectCateringCustomerAddresses = (state) => state.cateringCustomer.searchedCustomer?.addresses;
export const selectCateringPastOrders = (state) => state.cateringCustomer.pastOrders;
export const selectCateringActiveOrders = (state) => state.cateringCustomer.activeOrders;

export const selectCateringIsUserSearched = (state) => state.cateringCustomer.isUserSearched;
export const selectCateringSelectedAddress = (state) => state.cateringCustomer.selectedAddress;
export const selectCateringEditingAddress = (state) => state.cateringCustomer.editingAddress;
export const selectCateringIsEditMode = (state) => state.cateringCustomer.isEditMode;

// New selectors for catering-specific past orders
export const selectCateringServicePastOrders = (state) => state.cateringCustomer.cateringPastOrders;
export const selectCateringOrderDetails = (state) => state.cateringCustomer.cateringOrderDetails;